import Model from '../Model'

export default class VerifyUsers extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/users/verify'
    }
}
